import { Component } from '@angular/core';
import { DEVICE_SIZE } from '../../../../../core/models/others.model';

@Component({
  selector: 'main-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: false,
})
export class HeaderComponent {
  DEVICE_SIZE = DEVICE_SIZE;
}
